import React, { createContext, useContext, useState } from "react";
import { IUser } from "./interfaces/User";

interface UserContextProps {
  user: IUser;
  setUser: React.Dispatch<React.SetStateAction<IUser>>;
}

const UserContext = createContext<UserContextProps | undefined>(undefined);

const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isLocalhost = window.location.hostname === "localhost";
  const [user, setUser] = useState<IUser>({
    name: null,
    email: null,
    department: "",
    location: "",
    avatar: "",
    job_title: "",
    is_superuser: true,
    settings: isLocalhost
      ? {
          country: ["Czechia"],
          regulator: [
            "Municipal Courts of the Czech Republic (Legal)",
            "Regional Courts of the Czech Republic (Legal)",
          ],
          classes: ["Tort law"],
        }
      : {
          country: [],
          regulator: [],
          classes: [],
        },
    roles: [
      {
        team: {
          id: 12,
          name: "Czechia",
          regulators: [
            {
              id: 1,
              name: "Regional Courts of the Czech Republic (Tax)",
              code: "cz_regional",
            },
            {
              id: 3,
              name: "Supreme Administrative Court of the Czech Republic",
              code: "cz_administrative",
            },
          ],
        },
        right: "Admin",
      },
      {
        team: {
          id: 1,
          name: "Test Team",
          regulators: [
            {
              id: 1,
              name: "Regional Courts of the Czech Republic (Tax)",
              code: "cz_regional",
            },
            {
              id: 4,
              name: "Romanian Official Gazette",
              code: "ro_gazette",
            },
          ],
        },
        right: "Editor",
      },
      {
        team: {
          id: 10,
          name: "New 1",
          regulators: [
            {
              id: 7,
              name: "Hungarian Official Gazette",
              code: "hu_gazettes",
            },
          ],
        },
        right: "Viewer",
      },
      {
        team: {
          id: 9,
          name: "Team 2",
          regulators: [
            {
              id: 6,
              name: "Hungarian Parliament",
              code: "hu_parliament",
            },
          ],
        },
        right: "Viewer",
      },
      {
        team: {
          id: 2,
          name: "Team",
          regulators: [
            {
              id: 5,
              name: "Supreme Court of Hungary (Kúria)",
              code: "hu_supreme",
            },
          ],
        },
        right: "Admin",
      },
    ],
  });

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

const useUserContext = (): UserContextProps => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
};

export { UserProvider, useUserContext };
